import { loadViewComponent } from "@sinch/core/tools/viewLoader";
import { MessageDialog, MessageDialogProps } from "./MessageDialog";

loadViewComponent<MessageDialogProps>(MessageDialog, ".react-entrypoint-MessageDialog");
